




    import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
    import dataProxyService from "@/services/data-proxy.service";
    import { GrupaVozila } from '@/services/BackendProxies';

@Component({})
export default class GrupaVozilaEditor extends Vue {
    grupeVozila = [];
    @Prop() value !: string;

    model = '';

    async created() {
        const grupe = this.grupeVozila = await dataProxyService.vratiGrupeVozila();
        grupe.unshift(GrupaVozila.fromJS({id: '', naziv: '...'}));
        this.grupeVozila = grupe.map(gv => ({id: gv.id, text: gv.naziv}));
        this.model = this.value;
    }

    @Watch("value") onValueChange(val) {
        this.model = val;
    }

    @Watch("model") onModelChange(val) {
        this.input(val);
    }

    @Emit() input(val) {

    }

}
